import api from "../api/api";
import { LoginApiProps, LoginApiResponseProps } from "./props";

export const loginApi = async (data: LoginApiProps) => {
  return await api.post<LoginApiResponseProps>("/login", data);
};
